import { FileFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { DocumentIcons } from "styles/buildertrendTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconFileFilled: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <FileFilled {...props} style={{ ...props.style, color: DocumentIcons.Generic }} />;
};
